<template>
  <t-layout :showNav="false">
    <div class="page">
      <div class="main">
        <div class="logo"></div>
        <div class="form">
          <div class="item">
            <div style="width: 100%" class="item-inner">
              <div class="label">
                <img
                  src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/icon-phone.png"
                />
              </div>
              <div class="content">
                <van-field
                  class="formItem"
                  v-model="mobile"
                  type="number"
                  maxlength="11"
                  center
                  clearable
                  placeholder="请输入11位中国移动手机号码"
                />
              </div>
            </div>
          </div>

          <div class="item">
            <div class="item-inner">
              <div class="label">
                <img
                  src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/icon-Code.png"
                />
              </div>
              <div class="content">
                <van-field
                  class="formItem"
                  v-model="verifyCode"
                  center
                  clearable
                  placeholder="请输入短信验证码"
                />
              </div>
            </div>

            <van-button
              class="default-btn verify-btn"
              :class="timer !== 0 || !mobile || mobile.length < 11 ? 'verify-disabled' : ''"
              :disabled="timer !== 0 || !mobile || mobile.length < 11"
              @click="sendVerify"
              slot="button"
              size="small"
            >
              {{ timer > 0 ? '重新获取（' + timer + 's）' : '获取短信验证码' }}
            </van-button>
          </div>

          <div v-if="type !== 'B007'" class="bottom-tip">
            <div @click="haddleCheck" class="tap"></div>
            <div class="checkbox" :class="checked ? 'checked' : 'default'"></div>
            <div class="info">
              勾选代表您已阅读并同意<span @click="toMobileAgreement">《移动用户授权协议》</span>
            </div>
          </div>

          <div style="margin-bottom: 26rpx" class="submit">
            <van-button
              class="default-btn bind-btn"
              :class="!mobile || mobile.length < 11 || !verifyCode ? 'bind-disabled' : ''"
              :disabled="!mobile || mobile.length < 11 || !verifyCode"
              @click="submit"
              size="small"
            >
              确认提交
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'activityLotteryBind',
  components: {},
  data() {
    return {
      eventName: '绑定畅游平台账户',
      channel: '',
      tokenId: '',
      checked: false,
      mobile: '',
      type: '',
      verifyCode: '',
      timer: 0
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('/article/cy/auth') > -1) {
      this.$route.meta.isBack = true
    } else {
      this.$route.meta.isBack = false
    }
    next()
  },

  activated() {
    const options = this.$route.query

    const channel = options.channel || ''
    const mobile = options.mobile || ''
    const tokenId = decodeURIComponent(options.tokenId || '')
    const type = options.type || ''
    this.channel = channel
    this.mobile = mobile
    this.tokenId = tokenId
    this.type = type
    this.eventName = type == 'B007' ? '激活畅游平台账户' : '绑定畅游平台账户'

    this.flag = false

    this.$store.commit('setTitle', this.eventName)

    if (!this.$route.meta.isBack) {
      this.checked = false
      this.verifyCode = ''
    }
  },

  methods: {
    haddleCheck() {
      this.checked = !this.checked
    },

    toMobileAgreement() {
      this.$router.push({
        path: `/article/cy/auth`
      })
    },

    sendVerify() {
      let _this = this

      let { mobile, tokenId, type } = this

      mobile = mobile.replace(/\s/g, '')

      if (!mobile) {
        this.$toast({
          duration: 2000,
          message: '手机号不能为空'
        })
        return
      }

      if (!/^1[0-9]{10}$/.test(mobile)) {
        this.$toast({
          duration: 2000,
          message: '手机号码格式不正确'
        })

        return
      }

      this.$toast.loading({
        message: '获取验证码...',
        forbidClick: true,
        loadingType: 'spinner'
      })

      const apiMethods = type == 'B007' ? 'lotteryChangyouPointActSend' : 'lotteryChangyouPointSend'

      this.$api.lotteryPoints[apiMethods]({
        mobile,
        tokenId
      }).then(result => {
        let res = result.data
        // res.code = 0
        if (res.code == 0) {
          _this.timer = 60

          _this.tt = setInterval(function () {
            _this.timer = _this.timer - 1
            console.log('timer', _this.timer)
            if (_this.timer <= 0) {
              clearInterval(_this.tt)
            }
          }, 1000)

          this.$toast({
            duration: 2000,
            message: '验证码已发送'
          })
        }
      })
    },

    submit() {
      let { mobile, verifyCode, tokenId, checked, channel, type } = this

      if (type !== 'B007' && !checked) {
        this.$toast({
          duration: 2000,
          message: '请勾选移动用户授权协议'
        })
        return
      }

      if (this.flag) return
      this.flag = true

      console.log('mobile', mobile)
      console.log('verifyCode', verifyCode)

      let _this = this

      const apiMethods = type == 'B007' ? 'lotteryChangyouPointActBind' : 'lotteryChangyouPointBind'

      this.$toast.loading({
        message: '正在提交...',
        forbidClick: true,
        loadingType: 'spinner'
      })

      this.$api.lotteryPoints[apiMethods]({
        mobile,
        code: verifyCode,
        tokenId
      })
        .then(result => {
          let res = result.data
          // res.code = 0
          if (res.code == 0) {
            this.$toast({
              duration: 2000,
              message: '提交成功'
            })

            setTimeout(() => {
              this.$router.replace(`/activity/lottery/main?channel=${channel}`)
            }, 500)
          }
        })
        .finally(() => {
          _this.flag = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  color: #2e2e2e;
  background: #fff;
  min-height: 100vh;
}

.main {
  .logo {
    width: 100%;
    height: 454rpx;
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/mobile-logo-v2.png');
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 8rpx;
  }

  .form {
    padding: 0 48rpx;

    .item {
      width: 100%;
      display: flex;
      margin-bottom: 32rpx;
      font-size: 30rpx;

      .item-inner {
        flex: 1;
        background: #fff;
        display: flex;
        align-items: center;
        height: 88rpx;
        line-height: 88rpx;
        border-bottom: 2rpx solid #e5e5e5;

        .label {
          width: 68rpx;

          > img {
            display: block;
            width: 40rpx;
            height: 40rpx;
          }
        }

        .content {
          flex: 1;
          height: 88rpx;

          .formItem {
            padding-left: 0;
          }
          input {
            display: block;
            height: 100%;
          }
        }
      }

      .verify-btn {
        display: block;
        width: 244rpx;
        height: 88rpx;
        text-align: center;
        line-height: 88rpx;
        background: #0085cf;
        border-radius: 8rpx;
        margin-left: 32rpx;
        font-size: 26rpx;
        color: #fff;

        &.verify-disabled {
          background: #e5e5e5;
          color: #999999;
          opacity: 1;
        }
      }
    }

    .default-btn {
      border: 0;
      margin: 0;
      padding: 0;
      border-radius: 0;
      background: none;
      font-weight: normal;
    }

    .ph-style {
      font-size: 30rpx;
      color: #c8c8c8;
    }

    .bind-btn {
      margin-top: 128rpx;
      display: block;
      width: 100%;
      height: 98rpx;
      text-align: center;
      line-height: 98rpx;
      background: #0085cf;
      color: #fff;
      font-size: 36rpx;
      border-radius: 8rpx;

      &.bind-disabled {
        background: #f0f0f0;
        color: #c8c8c8;
        opacity: 1;
      }
    }
  }
}

.bottom-tip {
  display: flex;
  margin-top: 52rpx;
  position: relative;

  .tap {
    width: 120rpx;
    height: 32rpx;
    position: absolute;
    left: 0;
    top: 0;
  }

  .info {
    flex: 1;
    font-size: 26rpx;
    line-height: 32rpx;

    span {
      color: #0085cf;
    }
  }

  .checkbox {
    width: 32rpx;
    height: 32rpx;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 8rpx;

    &.checked {
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/checked.png');
    }

    &.default {
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/default.png');
    }
  }
}
</style>
